module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-width": "1000px",
      "height": "100%"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-col', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "span": 9
    }
  }, [_c('div', {
    staticClass: "imger imger1"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./img/login/Logo@2x.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "logo_span"
  }, [_vm._v("江苏狄诺尼")]), _vm._v(" "), _c('el-carousel', {
    staticClass: "lbt",
    staticStyle: {
      "height": "calc(100% - 100px)"
    },
    attrs: {
      "indicator-position": "outside"
    }
  }, _vm._l((_vm.lbt), function(item, index) {
    return _c('el-carousel-item', {
      key: index,
      staticStyle: {
        "height": "100%"
      }
    }, [_c('img', {
      staticClass: "lbt_img",
      attrs: {
        "src": item.imgUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "lbt_div"
    }, [_c('label', {
      staticClass: "lbt_title"
    }, [_vm._v(_vm._s(item.title))]), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "18px"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "lbt_span"
    }, [_vm._v(_vm._s(item.text))])])])
  }), 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "imger imger2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fwgw"
  }, [_vm._v("访问官网 →")])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card logins",
    staticStyle: {
      "width": "540px",
      "height": "680px"
    }
  }, [_c('div', {
    staticClass: "login_div"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "bak"
  }, [_vm._v("←返回")])]), _vm._v(" "), _c('span', {
    staticClass: "login_span"
  }, [_vm._v("用户注册")]), _vm._v(" "), _c('el-form', {
    ref: "registerForm",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.registerForm,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    staticClass: "register",
    attrs: {
      "prop": "name"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-yonghu",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone_input",
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.registerForm.name),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "name", $$v)
      },
      expression: "registerForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "register password",
    attrs: {
      "prop": "company"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-danweiguanli",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone_input",
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "公司全称"
    },
    model: {
      value: (_vm.registerForm.company),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "company", $$v)
      },
      expression: "registerForm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "register password",
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-weibiaoti-",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone_input",
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.registerForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "phone", $$v)
      },
      expression: "registerForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "register password",
    attrs: {
      "prop": "smsCode"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-yanzhengma",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone form-control",
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.registerForm.smsCode),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "smsCode", $$v)
      },
      expression: "registerForm.smsCode"
    }
  }), _vm._v(" "), (_vm.disabled == false) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v("发送验证码\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.disabled == true) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v(_vm._s(_vm.btntxt) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "register password",
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima1",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    class: {
      'pwd-disc': _vm.passwordHide
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.registerForm.password),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "password", $$v)
      },
      expression: "registerForm.password"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-view",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": function($event) {
        _vm.passwordHide = !_vm.passwordHide
      }
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "register password",
    attrs: {
      "prop": "conpassword"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-querenmima1",
    staticStyle: {
      "font-size": "16px"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    class: {
      'pwd-disc': _vm.conpasswordHide
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.registerForm.conpassword),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "conpassword", $$v)
      },
      expression: "registerForm.conpassword"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-view",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": function($event) {
        _vm.conpasswordHide = !_vm.conpasswordHide
      }
    },
    slot: "suffix"
  })])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "login_submit",
    attrs: {
      "type": "danger",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("提交注册")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "span_bottom"
  }, [_c('span', {
    staticStyle: {
      "line-height": "30px"
    }
  }, [_vm._v("\n            江苏狄诺尼信息技术有限责任公司 \n          ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n            CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. "), _c('a', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("苏ICP备18062906")])])])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a6a1fa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register.vue
// module id = 1133
// module chunks = 1